import '../css/Verify.css'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import "../css/Nav design.css";
import TopBar from './TopBar';
import { useEffect, useState } from 'react';
import LoginviaotpRequest from '../model/request/LoginviaotpRequest';
import OtpRequest from '../model/request/OtpRequest';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { getFCMToken } from "../utils/fcm";
import { requestForToken } from "../firebase";
import SaveFCMTokenRequest from '../model/request/Savefcmtoken';


function Loginviaotp() {
    var location = useLocation();
    var { userId, isFromRegistration, isFromForgot, mobileNumber, mobile, isOtpLogin } = location.state || {};

    console.log(location.state);

    const navigation = useNavigate()

    var [code, setCode] = useState("");
    var [codeError, setCodeError] = useState();
    const [fcmToken, setFcmToken] = useState("");
    const [timer, setTimer] = useState(0);
    const [isResendDisabled, setIsResendDisabled] = useState(false);

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;



    function clicktoVerifyscreen() {
        if (validation()) {
            if (!validation()) return;

            // if (!fcmToken) {
            //     showToastFailed("FCM token not generated. Please try again.");
            //     return;
            // }
            verifyLoginOtpAPICall();
        }
    }

    function validation() {
        var isFlage = true

        if (code == "") {
            setCodeError("please verify your code")
            isFlage = false
        }
        else {

            setCodeError("")

        }
        return isFlage;

    }

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }


    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    useEffect(() => {
        fetchFCMToken();

        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else {
            setIsResendDisabled(false);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [timer]);
    const fetchFCMToken = async () => {
        try {
            const permission = await Notification.requestPermission();
            console.log("Permission:", permission);

            const token = await requestForToken();
            console.log("Generated FCM Token:", token);

            if (token) {
                setFcmToken(token);
            } else {
                console.log("Token is null");
            }
        } catch (err) {
            console.error(err);
        }
    };


    async function verifyLoginOtpAPICall() {
        var request = new LoginviaotpRequest();
        request.user_Id = userId;
        request.otp = code;
        request.fcmToken = fcmToken;
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/MobverifyOTP"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(async (response) => {

                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api);
                if (api.status == true && api.statusCode == 200) {
                    showToast("OTP Verified successfully!.")

                    if (isOtpLogin) {

                        localStorage.setItem("token", api.response.token);
                        localStorage.setItem("loginVal", JSON.stringify(api.response));

                        await saveFCMToken(api.response.user_Id);
                        navigation("/Viewpage", { replace: true });
                        return;
                    }
                    else {

                        setTimeout(() => {
                            navigation('/login');
                        }, 100);
                    }




                } else {
                    showToastFailed("Invalid OTP")
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }


    async function saveFCMToken(userId) {

        const token = await requestForToken();

        if (!token) {
            console.log("FCM Token not generated");
            return;
        }

        const request = new SaveFCMTokenRequest();

        request.user_Id = userId;
        request.fcmToken = token;
        request.deviceType = "WEB";

        try {

            const response = await axios.post(
                ApiConfig.getUrl("User/saveFCMToken"),
                JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            console.log("FCM Saved:", response.data);

        } catch (err) {
            console.log("Save FCM Error:", err);
        }
    }

    function resendOtpAPICall() {
        var request = new OtpRequest();
        request.userId = userId;
        request.message = "OTP resend successfully!.";
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/sendSMSOTP"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api);
                if (api.status === true && api.statusCode === 200) {

                    showToast(api.message);
                    setIsResendDisabled(true);
                    setTimer(60);

                    //  localStorage.setItem("token", api.response.token);
                    //  localStorage.setItem("loginVal", JSON.stringify(api.response));

                    // navigation("/Viewpage", { replace: true });

                    return;
                } else {
                    showToastFailed("Resend OTP Failed")
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    const disableRightClick = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <div onContextMenu={disableRightClick}>
                <TopBar />
                <ToastContainer />

                <div className='fullview' style={{ backgroundColor: 'white' }}>

                    <div className="card  h-100 w-100s" >
                        <p className="h5 text-center mt-2 pt-2">OTP Verification</p>
                        <p className="h6 text-center ">Enter the 4-digit code sent to your Mobile Number</p>

                        <div className="otp-input mt-2 ms-1 ">
                            <input type="number" max="1" required value={code} onChange={(e) => setCode(e.target.value)} />


                        </div>
                        <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>

                            <button onClick={clicktoVerifyscreen} type="button" className='btn' style={{ background: "var(--primary-color)", fontWeight: "bold" }} >Verify</button>
                        </div>
                        <span className='input-error'>{codeError}</span>
                        <p className="h6 text-center">
                            Didn't receive code yet?{" "}

                            <span
                                onClick={!isResendDisabled ? resendOtpAPICall : undefined}
                                style={{
                                    color: isResendDisabled ? "gray" : "orange",
                                    cursor: isResendDisabled ? "not-allowed" : "pointer",
                                    textDecoration: "underline"
                                }}
                            >
                                Resend Code
                            </span>

                            {isResendDisabled && (
                                <span style={{ marginLeft: "10px", color: "red" }}>
                                    ({Math.floor(timer / 60)}:
                                    {String(timer % 60).padStart(2, "0")})
                                </span>
                            )}
                        </p>

                    </div>
                </div>
            </div>
            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>

    );
}

export default Loginviaotp;